export default __webpack_public_path__ + "static/media/RunHorseLight_4_2.55fea838.jpg";